import React from "react";

import { Container, Row, Col, Button } from "reactstrap";
import { Helmet } from "react-helmet";

import NavbarPrimary from "../sections/NavbarPrimary.js";
import Footer from "../sections/Footer.js";
import UkCbdcHeader from "../headers/UkCbdcHeader.js";
import PreFooterContactUs from "../sections/PreFooter.js";
import IntelMain from "../blogs/IntelMain.js";

function Intel() {
  const style = { width: "100%" };
  React.useEffect(() => {
    document.body.classList.add("index");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    let href = window.location.href.substring(
      window.location.href.lastIndexOf("#") + 1
    );
    if (
      window.location.href.lastIndexOf("#") > 0 &&
      document.getElementById(href)
    ) {
      document.getElementById(href).scrollIntoView();
    }
    return function cleanup() {
      document.body.classList.remove("index");
    };
  });
  return (
    <>
      <Helmet>
        <title>CrypTegridy - UK CBDC</title>
        <meta name="description" content="An in-depth analysis of the UK CBDC and its implications for the financial industry." />
        <meta name="keywords" content="CrypTegridy, UK CBDC, digital currency, crypto, security, protection, intelligence" />
      </Helmet>
      <NavbarPrimary />
      <div className="wrapper">
        <Button
          className="btn-icon-only back-to-top text-lowercase text-default show"
          color="info"
          name="button"
          type="button"
          onClick={() => {
            window.scrollTo(0, 0);
            document.body.scrollTop = 0;
          }}
        >
          &alpha;
        </Button>
        <UkCbdcHeader />
        <section className="section">
          <Container>
            <Row>
              <Col className="ml-auto mr-auto" md="8">
                <h6 className="category">January 21, 2024</h6>
                <h3 className="title">
                  The Future of Money in the UK: A Shift to Digital
                </h3>
                <p className="font-weight-normal">
                  According to<a href="https://www.bankofengland.co.uk/quarterly-bulletin/2022/2022-q3/knocked-down-during-lockdown-the-return-of-cash" target="_blank" rel="noreferrer" 
                  className=" text-info"> The Bank of England</a>, 23 million people in the UK did not use 
                  cash at all in 2021. United Kingdom is<a href="https://www.bankofengland.co.uk/the-digital-pound" target="_blank" rel="noreferrer" 
                  className=" text-info"> exploring the possibility</a> of introducing a central bank digital currency 
                  <a href="https://www.bankofengland.co.uk/the-digital-pound#:~:text=Central%20bank%20digital%20currency%20(CBDC)%20is%20money%20that%20a%20central,a%20computer%20or%20similar%20device." target="_blank" rel="noreferrer" 
                  className=" text-info">&#40;CBDC&#41;</a> tied to the British pound. Other European countries, such as 
                  Denmark and Sweden, are also considering the implementation of similar initiatives, while the European 
                  Central Bank is investigating the potential of a<a href="https://www.ecb.europa.eu/paym/digital_euro/html/index.en.html" target="_blank" rel="noreferrer" 
                  className=" text-info"> digital euro</a>.
                </p>
                <p className="font-weight-normal">
                  Given the high gas fees associated with cryptoassets like bitcoin, CBDCs aim to offer lower transaction 
                  fees and increased efficiency in cross-border payments. However, there are also privacy concerns associated 
                  with the implementation of CBDCs, as they would require trust in central banks, governments, and third 
                  parties to prevent the abuse of control over the currency's supply.
                </p>
                <p className="font-weight-normal">
                  In the world of digital currencies, there are two distinct categories: centralized finance &#40;CeFi&#41; and 
                  decentralized finance &#40;DeFi&#41;. CeFi is a traditional financial system that relies on centralized 
                  intermediaries and intermediation to facilitate transactions, whereas DeFi is a new model of financial services 
                  built on top of public blockchain networks, where users retain full control of their assets and private keys.
                </p>
              </Col>
            </Row>
          </Container>
        </section>
        <section>
          <Col md="7" className="mx-auto">
            <img
              alt="..."
              className="img-fluid rounded"
              src={require("assets/img/blogs/flag.jpg")}
              style={style}
            ></img>
          </Col>
        </section>
        <section>
          <Container>
            <Row>
              <Col className="mx-auto mb-5" md="8">
                <br></br>
                <h3 className="title">
                  What does this mean for the future of finance in the UK?
                </h3>
                <p className="font-weight-normal">
                  The relationship between CeFi and DeFi is currently one of competition, as each system offers 
                  different advantages and disadvantages. CeFi is often seen as more secure and reliable, as it 
                  is regulated by governments and financial institutions, and backed by traditional financial 
                  infrastructure. However, CeFi also often comes with higher fees and less accessibility, 
                  especially for those who do not have access to traditional financial services.
                </p>
                <p className="font-weight-normal">
                  On the other hand, DeFi operates on decentralized infrastructure, such as blockchain technology, 
                  and offers increased accessibility, lower fees, and faster transaction times through the use of 
                  cryptoassets. However, DeFi is often considered less secure and reliable, as it is not backed by 
                  traditional financial institutions.
                </p>
                <p className="font-weight-normal">
                  The future of CBDCs and other digital currencies remains uncertain and will depend on the 
                  development of further regulatory frameworks to address the technical and ethical challenges 
                  associated with these assets. Until such policies and frameworks are in place, it is difficult 
                  to predict the outcome of the interaction between CBDCs, cryptoassets, and other digital currencies 
                  leveraging blockchain technology. The comparison between CeFi and DeFi highlights the need for 
                  further innovation and exploration in the realm of digital currencies, as well as the importance 
                  of balancing the benefits of decentralization with the need for financial compliance and privacy 
                  protections.
                </p>
                <h3 className="title">
                  Some Things To Consider
                </h3>
                <p className="font-weight-normal">
                  While it is possible that CeFi and DeFi will continue to compete in the future, some experts believe 
                  that the two systems will eventually converge and merge. This would result in a financial system that 
                  offers the security and reliability of CeFi, with the accessibility and efficiency of DeFi. In order 
                  for CeFi and DeFi to converge, significant investment, regulatory support, and technological 
                  advancements, particularly in blockchain and cryptoasset technology, would be necessary. The future 
                  of the relationship between CeFi and DeFi will likely depend on various factors, such as market trends, 
                  consumer preferences, and government policies, among others.
                </p>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="section section-blog">
                <IntelMain />
        </section>
        <section className="section">
          <PreFooterContactUs />
        </section>
        <Footer />
      </div>
    </>
  );
}

export default Intel;
